import api from '@/libs/axios'
import { OpportuniteByStatutModel, ShortOpportunite } from '../models/opportunites/opportunite'

const resource = 'Opportunites'

export default class OpportunitesResource {
  public async listByStatut(responsableId: string, natureOffre: string, entrepriseId: string) : Promise<OpportuniteByStatutModel[]> {
    const params = new URLSearchParams();

    if (natureOffre) params.append("NatureOffre", natureOffre);
    if (responsableId) params.append("ResponsableId", responsableId);
    if (entrepriseId) params.append("EntrepriseId", entrepriseId);

    const response = await api.get(`${resource}/ByStatut`, { params: params })
    return response.data
  }

  public async paginatedList(
    pagenumber?: number,
    pagesize?: number,
    orderBy?: string,
    orderByDescending?: boolean,
    search?: string,
    statut?: string,
    responsable?: string,
    natureOffre?: string,
    joursSansAction?: number
  ) : Promise<ShortOpportunite[]> {
    const params = new URLSearchParams();

    if (pagenumber) params.append("PageNumber", pagenumber.toString());
    if (pagesize) params.append("PageSize", pagesize.toString());
    if (orderBy) params.append("OrderBy", orderBy.toString());
    if (orderByDescending)
      params.append("OrderByDescending", orderByDescending.toString());
    if (search) params.append("Search", search);
    if (statut) params.append("Statut", statut);
    if (responsable) params.append("ResponsableId", responsable);
    if (natureOffre) params.append("NatureOffre", natureOffre);
    if (joursSansAction) params.append("SansActionsDepuisNbJours", joursSansAction.toString());

    const response = await api.get(`${resource}`, { params: params })
    return response.data
  }
}
